// src/features/tasks/components/TaskDetailsPage/AddManualsDialog.jsx
import React from 'react';
import SelectFileDialog from '../../../files/components/SelectFileDialog';
import { useTranslation } from 'react-i18next';

/**
 * AddManualsDialog - Dialog for selecting multiple files to link as task manuals
 * Uses the SelectFileDialog component with multi-select enabled
 */
export function AddManualsDialog({
  open,
  onClose,
  onSubmit,
  linkedFileIds = [],
  submitLoading = false,
  submitError = null,
}) {
  const { t } = useTranslation(["tasks"]);

  const handleSelectFiles = (fileIds) => {
    // fileIds is an array of file IDs from the multi-select dialog
    if (fileIds && fileIds.length > 0) {
      onSubmit(fileIds);
    }
  };

  return (
    <SelectFileDialog
      open={open}
      onClose={onClose}
      onSelectFile={handleSelectFiles}
      multiSelect={true}
      excludedFileIds={linkedFileIds}
      title={t("tasks:actions.addManuals")}
      loading={submitLoading}
      error={submitError}
      allowUpload={true}
    />
  );
}
